import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { MarkCalculationMethod } from '@examdojo/models/markscheme-v2';
import { QuestionItemV2 } from '@examdojo/models/question';
import { QuestionEditingOptions, QuestionEditorState } from '@examdojo/models/question-editor';
import { QuestionImageCacheService } from '@examdojo/question-image';
import { ModalController } from '@ionic/angular/standalone';
import { QuestionItemsEditorComponent } from '../question-items-editor.component';
import { provideQuestionItemsForm } from '../question-items-form.service';
import { QuestionItemsPreviewFormService } from './question-items-preview-form.service';

@Component({
  selector: 'dojo-question-items-preview',
  template: `
    <dojo-question-items-editor
      [isSelectingDisabled]="true"
      [markCalculationMethod]="markCalculationMethod()"
      [calculatorAllowed]="calculatorAllowed()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [QuestionItemsEditorComponent],
  providers: [provideQuestionItemsForm(QuestionItemsPreviewFormService)],
})
export class QuestionItemsPreviewComponent {
  constructor(
    private readonly modalCtrl: ModalController,
    private readonly questionItemsFormService: QuestionItemsPreviewFormService,
    private readonly questionImageCacheService: QuestionImageCacheService,
  ) {
    effect(() => {
      this.questionItemsFormService.initializeForm(this.questionItems());
    });
    effect(() => {
      this.questionItemsFormService.editingOptions$.next(this.editingOptions());
    });
    effect(() => {
      this.questionImageCacheService.loadFromCache(this.imageCache());
    });
  }

  readonly imageCache = input<QuestionEditorState['imageCache']>({});

  readonly markCalculationMethod = input.required<MarkCalculationMethod>();

  readonly questionItems = input.required<QuestionItemV2[]>();

  readonly calculatorAllowed = input<boolean>(false);

  readonly editingOptions = input<QuestionEditingOptions | null>({
    allowImageEditing: [],
    allowQuestionEditing: false,
    allowMarkschemeEditing: false,
    allowMcqEditing: false,
    hideBadges: false,
  });

  closeDialog() {
    this.modalCtrl.dismiss();
  }
}
